import AppEvents from '@/AppEvents';
import axios from 'axios';
import { ICredentials } from '../models/ICredentials';
import { BaseService } from './BaseService';

class AuthService extends BaseService {

    private static instance: AuthService;

    private constructor() {  super(); }

    public static get Instance() {
       // Do you need arguments? Make it a regular method instead.
       return this.instance || (this.instance = new this());
    }

    public async loginAsync(credentials: ICredentials): Promise<string> {
        try {
            const res = await axios.post(`${this.api}/auth/login`, credentials)
            return res.data.auth_token as string;
        } catch (e){
            AppEvents.handleApiError(e);
        }
    }

    public async azureAdSignInOrSignUp(): Promise<string> {
        try {
            const res = await axios.post(`${this.api}/auth/azureAdSignInOrSignUp`, null, {withCredentials: true})
            return res.data.auth_token as string;
            
        } catch (e){
            AppEvents.handleApiError(e);
        }
    }
}

// export a singleton instance in the global namespace
export const authService = AuthService.Instance
